import { createAction, createSelector, createSlice } from '@reduxjs/toolkit';
import { createSliceSelector } from './utils/createSliceSelector';
// const initialState: HighlightState = {path: null, ids: []};
const initialState = null;
export const setHover = createAction('setHover');
export const hoverSlice = createSlice({
    name: 'hover',
    initialState,
    reducers: {},
    extraReducers: (builder) => builder.addCase(setHover, (state, { payload }) => payload),
});
export const hoverSelectionSelector = createSliceSelector(hoverSlice);
export const hoverSelector = createSelector(hoverSelectionSelector, (state) => state);
